import styles from './SolutionsHero.module.css'

const SolutionsHero = () => {
  return (
    <section id="solutions-hero" className={styles.section}>
      <div className={styles.background}>
        <div className={styles.blob1} />
        <div className={styles.blob2} />
      </div>

      <div className="container">
        <div className={styles.content}>
          <h1 className={styles.title}>
            Custom software and{' '}
            <span className="gradient-text">AI integration</span>{' '}
            for your business.
          </h1>
          <p className={styles.subtitle}>
            We build custom software, organize your data, and improve the processes
            slowing your team down, with AI applied where it saves real time. The
            goal: software that fits how your business runs and gives your team
            time back.
          </p>
        </div>
      </div>
    </section>
  )
}

export default SolutionsHero
